<template>
  <div v-if="!isLoading">
    <div>
      <div class="row mx-0 mt-2 mb-3 justify-content-between">
        <div class="main-color-text bold-text"> {{ $t('operation.bilan.Construction').toUpperCase() }}</div>
        <div class="row mx-0 align-items-center">
          <div class="row mx-0 align-items-center">
            <b-link class="main-color-text bold-text mr-3" v-on:click="exportToExcel()">
              {{ $t('operation.bilan.exporter') }}
              <file-download-icon size="18"/>
            </b-link>
            <b-link class="main-color-text bold-text ml-3" v-on:click="clickOnEditBtn()">
              {{ $t('Modify') }}
              <pencil-icon size="18"/>
            </b-link>
          </div>
        </div>
      </div>

      <b-table
        :fields="tableFieldsConstructions"
        :items="itemsConstruction"
        :tbody-tr-class="rowClass"
        :thead-class="'row-header'"
        borderless
        class="light-border"
        striped>
        <template #cell(type)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(HT)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TVA)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TTC)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
      </b-table>

    </div>

  </div>
</template>

<script>

import api from "../../../services/api";
import B122Table from "../../../components/b122/B122Table.vue";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal.vue";
import ExcelJS from "exceljs";

export default {
  name: "OperationShowConstruction",

  components: {
    ItemDeleteModal,
    B122Table
  },

  props: {
    operationId: {
      default: null
    },
    operationBilanId: {
      default: null
    },
    simulationId: {
      default: null
    },
    currentMode: {
      default: 'budget'
    },
    operationName: {
      default: ''
    }
  },

  data() {
    return {
      needFacture: false,
      statusDevis: [],
      isLoading: false,
      tableFieldsConstructions: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsConstruction: [],
      cellStyle: {
        alignment: {vertical: 'middle', horizontal: 'center'},
        font: {name: 'Calibri', color: {argb: '000000'}},
        fill: {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFFFFF'}},
        border: {
          top: {style: 'thin', color: {argb: 'd6d2d2'}},
          left: {style: 'thin', color: {argb: 'd6d2d2'}},
          bottom: {style: 'thin', color: {argb: 'd6d2d2'}},
          right: {style: 'thin', color: {argb: 'd6d2d2'}}
        }
      },
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.getOperationBilanType()
      await this.getConstructionData()
      await this.getStatusDevis()
    },

    async getStatusDevis() {
      await api
        .get(`/operationDevis/getStatusDevis`)
        .then(response => {
          this.statusDevis = response.data
        })
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus();
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...';
      }
      return text;
    },


    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section-margin') return 'row-title-section row-margin'
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    async getConstructionData() {
      this.isLoading = true
      api
        .get(`/operationBilan/getConstructionData/${this.operationId}`)
        .then(response => {
          this.itemsConstruction = response.data['itemsConstruction']
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
            })
          }
        })
    },

    async getOperationBilanType() {
      this.isLoading = true
      api
        .get(`/operationBilan/getOperationBilanType/${this.operationBilanId}`)
        .then(response => {
          if (response.data.bilanType === 'EXE') {
            this.needFacture = true
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
            })
          }
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationBilanConstructionEdit',
        params: {
          operationId: this.operationId,
          operationBilanId: this.operationBilanId,
          simulationId: this.simulationId
        }
      })
    },


    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    async exportToExcel() {
      let workbook = new ExcelJS.Workbook();

      let chargesWorksheet = workbook.addWorksheet('Travaux');
      let tableFieldsExportConstructions = [...this.tableFieldsConstructions]
      tableFieldsExportConstructions.push({label: 'Restant à payer TTC', key: 'rap', thStyle: {width: "15%"}})
      tableFieldsExportConstructions.push({label: 'factures', key: 'factures', thStyle: {width: "15%"}})
      tableFieldsExportConstructions.push({label: 'devis', key: 'devis', thStyle: {width: "15%"}})
      this.exportTableToWorksheet(chargesWorksheet, tableFieldsExportConstructions, this.itemsConstruction);


      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(new Blob([buffer]), `Travaux-${this.operationName}.xlsx`);
    },

    exportTableToWorksheet(worksheet, tableFields, tableItems) {
      worksheet.views.showGridLines = false;

      worksheet.columns = tableFields.map(field => {
        return {header: field.label, key: field.key, width: 20};
      });

      this.setHeaderStyle(worksheet.getRow(1));
      this.processTableItems(worksheet, tableItems);
    },

    setHeaderStyle(headerRow) {
      headerRow.height = 35;
      headerRow.eachCell(cell => {
        this.setCellStyle(cell, this.cellStyle);
        cell.font = {...this.cellStyle.font, bold: true, size: 12, color: {argb: '07153C'}};
      });
    },

    processTableItems(worksheet, tableItems) {
      tableItems.forEach((item, index) => {
        let translatedItem = this.translateItem(item);

        let newRow = worksheet.addRow(translatedItem);

        newRow.eachCell((cell, colNumber) => {
          newRow.height = 35;
          this.setCellStyle(cell, this.cellStyle);

          if (index === 0) {
          } else if (index % 2 === 0) {
            cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: 'EEEEEE'}};
          }

          if (translatedItem.type.includes('Total')) {
            this.setCellStyle(cell, {
              fill: {type: 'pattern', pattern: 'solid', fgColor: {argb: '07153C'}},
              font: {color: {argb: 'FFFFFF'}}
            });
          }

          if (colNumber === 1) {
            worksheet.getColumn(colNumber).width = worksheet.name === "Global" ? cell.value.length * 2 : cell.value.length * 1.5;
          }
          if(colNumber !== 6 && colNumber !== 7 ){
            cell.numFmt = '#,##0 "€";[Red]\\-#,##0 "€"';
          }

          this.setSpecialCellStyle(cell, item);
        });
      });
    },

    translateItem(item) {
      let translatedItem = {...item};
      translatedItem.type = this.$t(item.type);
      translatedItem.lot = this.$t(item.lot);
      translatedItem.nom = this.$t(item.nom);

      translatedItem.HT = item.HT !== '' ? this.removeWhitespace(item.HT) : item.HT;
      translatedItem.TTC = item.TTC !== '' ? this.removeWhitespace(item.TTC) : item.TTC;
      translatedItem.TVA = item.TVA !== '' ? this.removeWhitespace(item.TVA) : item.TVA;
      translatedItem.rap = item.rap !== '' ? this.removeWhitespace(item.rap) : item.rap;
      translatedItem.devis = item.devis !== '' ? this.removeWhitespace(item.devis) : item.devis;
      translatedItem.factures = item.factures !== '' ? this.removeWhitespace(item.factures) : item.factures;
      if (typeof item.taux === 'number') {
        translatedItem.taux = item.taux + ' %';
      }

      return translatedItem;
    },

    setCellStyle(cell, style) {
      Object.assign(cell, style);
    },

    setSpecialCellStyle(cell, item) {
      if (item.status === 'title-section') {
        this.setCellStyle(cell, {font: {name: 'Calibri', color: {argb: '07153C'}, bold: true, size: 12}});
      } else if (item.status === 'total-primary') {
        this.setCellStyle(cell, {
          font: {name: 'Calibri', color: {argb: 'FFFFFF'}, bold: true},
          fill: {type: 'pattern', pattern: 'solid', fgColor: {argb: '07153C'}}
        });
      } else if (item.status === 'subtitle') {
        this.setCellStyle(cell, {font: {name: 'Calibri', color: {argb: '9E0430'}, bold: true}});
      }
    },

    removeWhitespace(input) {
      if (typeof input === 'string') {
        return Number(input.replace(/\s+/g, ''));
      } else {
        return input;
      }
    },


  }
}
</script>

<style scoped>

.no-result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: grey;
}

.no-result-text {
  text-align: center;
  max-width: 400px;
}

.no-result-title {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  color: var(--main-color-text);
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowConstruction.vue